import {Component, inject} from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';
import {MatDialog} from "@angular/material/dialog";
import {ColorRecordTableModalComponent} from "./color-record-table-modal/color-record-table-modal.component";
import {Position} from "../../../../types/position.types";

@Component({
  selector: 'app-color-record-table-item',
  standalone: false,
  templateUrl: './color-record-table-item.component.html',
  styleUrls: [
    './color-record-table-item.component.scss',
    '../base-record-table-item-styles.scss'
  ],
})
export class ColorRecordTableItemComponent extends BaseRecordTableItemComponent {
  private dialog: MatDialog = inject(MatDialog);

  public openColorModal(event: MouseEvent) {
    const position = this.getPositionModal(event);

    this.dialog.open(ColorRecordTableModalComponent, {
      data: {
        selectedColor: this.value,
        position: position
      },
      disableClose: false
    }).afterClosed().subscribe((result) => {
      if (!result) { return; }

      this.handleValueChange(result);  // Обновляем значение в родительском компоненте
    });
  }

  private getPositionModal(event: MouseEvent): Position {
    const clickX = event.clientX;
    const clickY = event.clientY;

    return {
      top: clickY,
      left: clickX
    };
  }
}
